import _ from 'underscore';
import Backbone from 'backbone';
import Global from 'models/Global';
import TemplatesConfig from 'web-common/scripts/TemplatesConfig';
import twitterText from 'twitter-text';
import rewriteLegacyS3ResourceUrls from '../utils/LegacyS3ResourceUrls';

var Section = Backbone.RelationalModel.extend({

    parse: function(response) {
        response = rewriteLegacyS3ResourceUrls(response);
        if (response.type === 'multiElement') {
            response.elements = this.multiSectionParse(response);
        }
        var result = this.parseByType(response);
        return result;
    },

    multiSectionParse: function(section) {
        var elements = section.elements;
        var elToRender = [];
        var grid = [];
        _.each(elements, function(element) {
            if (element.grid) {
                grid.push(element);
                return;
            } else {
                if (grid.length > 0) {
                    elToRender.push({type: 'multiElement', entities: grid});
                    grid = [];
                }
                elToRender.push(element);
            }
        }, this);
        return elToRender;
    },

    parseByType: function(response) {
        var elements = response.elements || [];
        _.each(elements, function(element) {
            if (element.type == 'description') {
                element.safeHtmlDescription = twitterText.autoLinkUrlsCustom(twitterText.htmlEscape(element.text || ''), {urlTarget: '_top'});
            } else if (element.type == 'eventVenue') {
                element = _.extend(element, element.venue);
            } else if (element.type == 'image' && response.type == 'header') {
                !element.url && this.getRandomImage(element);
            } else if (element.type == 'form') {
                _.each(element.form.included, function(formField) {
                    formField.layout = element.layout;
                });
            }
            response[element.type] = element;
        }, this);
        return response;
    },

    getRandomImage: function(response) {
        var eventId = Global.get('event') ? Global.get('event').get('id') : this.collection.eventId;
        var images = TemplatesConfig.images;
        var randomImage = images[eventId % images.length];

        response.url = randomImage;
        response.imagePhotoSet = {
            small: randomImage,
            mediumL: randomImage,
            large: randomImage
        };
    }
});
export default Section;

